import script from "./NavbarNewC.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarNewC.vue?vue&type=script&setup=true&lang=js"

import "./NavbarNewC.vue?vue&type=style&index=0&id=6cf48c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf48c38"]])

export default __exports__